export const getMobileState = (state) => state.mobile;